module.exports = __webpack_public_path__ + "ath_game_web/img/7.1.2__5.1.15ceb5bb.png";